module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foo training-types-page"
  }, [_c('div', {
    staticClass: "foo training-types-header"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_training_type_title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "foo section-bottom-sm training-types-add-row"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newKit),
      expression: "newKit"
    }],
    staticClass: "input width-half training-types-add-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_training_type_add'),
      "name": "Dodaj novi tip"
    },
    domProps: {
      "value": (_vm.newKit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newKit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "training-types-add-btn-wrap"
  }, [_c('i', {
    staticClass: "ti-plus section-title-clickable training-types-add-btn",
    on: {
      "click": function($event) {
        return _vm.addNewKit()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row training-types-table-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width training-types-table-wrap"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kits), function(k) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(k))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteKit(k)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                  ")])])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2d210b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Payment/TrainingTypes.vue
// module id = 813
// module chunks = 0